import { Menu, MenuItem } from "@mui/material";
import SwapVertOutlinedIcon from "@mui/icons-material/SwapVertOutlined";
import { FilterAndSortButton, sortMenuStyles } from "./styles";
import { SortMenuProps } from "./types";
import { useContext, useEffect, useState } from "react";
import { THEME } from "../../theme";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { UserDetailsContext } from "../../contexts";
import { useParams } from "react-router-dom";

export const SortMenu: React.FC<SortMenuProps> = ({
  setFilterAndSortParams,
  filterAndSortParams,
  setPage,
  setFilterAndSortChanged,
  setTracks,
  handleRefreshTracks,
}) => {
  const [sortAnchorEl, setSortAnchorEl] = useState<null | HTMLElement>(null);
  const openSortMenu = Boolean(sortAnchorEl);
  const { enterprise } = useContext(UserDetailsContext);
  const { id } = useParams();

  const handleOpenSortDropdown = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setSortAnchorEl(event.currentTarget);
  };

  const handleSortDropdownClose = () => {
    setSortAnchorEl(null);
  };

  useEffect(() => {
    if (
      filterAndSortParams.isAscending === false &&
      filterAndSortParams.genreList.length === 0 &&
      filterAndSortParams.artistList.length === 0 &&
      filterAndSortParams.collaboratorsList.length === 0 &&
      filterAndSortParams.TrackPrivacy === "All" &&
      filterAndSortParams.bpmStartValue === 0 &&
      filterAndSortParams.bpmEndValue === 200 &&
      filterAndSortParams.sortBy === "Last modified" &&
      filterAndSortParams.status === "" &&
      enterprise?.id === undefined &&
      id === undefined
    ) {
      setFilterAndSortChanged(false);
      handleRefreshTracks();
    } else {
      setPage(0);
      setFilterAndSortChanged(true);
      setTracks([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    filterAndSortParams.TrackPrivacy,
    filterAndSortParams.artistList.length,
    filterAndSortParams.bpmEndValue,
    filterAndSortParams.bpmStartValue,
    filterAndSortParams.collaboratorsList.length,
    filterAndSortParams.genreList.length,
    filterAndSortParams.isAscending,
    filterAndSortParams.sortBy,
    filterAndSortParams.status,
    setFilterAndSortChanged,
    setPage,
    setTracks,
    enterprise?.id,
  ]);

  return (
    <>
      <FilterAndSortButton
        aria-controls={openSortMenu ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openSortMenu ? "true" : undefined}
        onClick={handleOpenSortDropdown}
        sx={sortMenuStyles.button}
      >
        <SwapVertOutlinedIcon sx={{ margin: "5px" }} />
        Sort
      </FilterAndSortButton>
      <Menu
        id="basic-menu"
        anchorEl={sortAnchorEl}
        open={openSortMenu}
        onClose={handleSortDropdownClose}
        PaperProps={{
          style: sortMenuStyles.paperProps,
        }}
        sx={sortMenuStyles.menu}
      >
        <MenuItem
          sx={{ marginTop: 0 }}
          onClick={() => {
            setFilterAndSortChanged(true);
            setFilterAndSortParams((prev) => {
              return {
                ...prev,
                sortBy: "Title",
              };
            });
            setPage(0);
            setTracks([]);
            handleSortDropdownClose();
          }}
        >
          <img
            style={{
              margin: "2px",
              marginRight: "8px",
              filter: THEME === "light" ? "invert(100%)" : "invert(0%)",
            }}
            src="/assets/icons/TracksPageIcons/music-equalizer--music-audio-note-wave-sound-equalizer-entertainment.svg"
            alt=""
          />
          Title
        </MenuItem>
        <MenuItem
          onClick={() => {
            setFilterAndSortChanged(true);
            setFilterAndSortParams((prev) => {
              return {
                ...prev,
                sortBy: "Artist",
              };
            });
            setPage(0);
            setTracks([]);
            handleSortDropdownClose();
          }}
        >
          <img
            style={{
              margin: "2px",
              marginRight: "8px",
              filter: THEME === "light" ? "invert(100%)" : "invert(0%)",
            }}
            src="/assets/icons/TracksPageIcons/user-square.svg"
            alt=""
          />
          Artist
        </MenuItem>
        <MenuItem
          onClick={() => {
            setFilterAndSortChanged(true);
            setPage(0);
            setTracks([]);
            setFilterAndSortParams((prev) => {
              return {
                ...prev,
                sortBy: "Last Modified",
              };
            });
            handleSortDropdownClose();
          }}
        >
          <img
            style={{
              margin: "2px",
              marginRight: "8px",
              filter: THEME === "light" ? "invert(100%)" : "invert(0%)",
            }}
            src="/assets/icons/TracksPageIcons/clock.svg"
            alt=""
          />
          Last modified
        </MenuItem>
        <MenuItem
          onClick={() => {
            setFilterAndSortChanged(true);
            setPage(0);
            setTracks([]);
            setFilterAndSortParams((prev) => {
              return {
                ...prev,
                sortBy: "Notifications",
              };
            });
            handleSortDropdownClose();
          }}
        >
          <NotificationsIcon sx={{ fontSize: "25px", marginRight: "8px" }} />
          Notifications
        </MenuItem>
      </Menu>
    </>
  );
};
